import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api";

function AddStaff() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
  });
  const navigate = useNavigate();

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    Object.keys(form).forEach((key) => data.append(key, form[key]));

    try {
      const res = await api.post("/staff", data);

      alert(
        `Staff registered!\nEmail: ${res.data.credentials.email}\nPassword: ${res.data.credentials.password}`
      );
      navigate("/jewellers/Staff");
    } catch (err) {
      console.error("API Error:", err.response?.data || err.message);
      alert("Error adding staff");
    }
  };

  return (
    <div className="p-8 max-w-lg mx-auto">
      <div className="bg-white shadow-lg rounded-2xl p-8 border border-gray-100 transition-all hover:shadow-2xl">
        <h1 className="text-2xl font-bold text-gray-800 text-center mb-8">
          Register New Staff
        </h1>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Name
            </label>
            <input type="text" name="name" placeholder="Enter full name" value={form.name} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-purple-500 transition" required />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <input type="email" name="email" placeholder="Enter email address" value={form.email} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-purple-500 transition" required />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Phone
            </label>
            <input type="text" name="phone" placeholder="Enter phone number" value={form.phone} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-purple-500 transition" required />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Address
            </label>
            <textarea name="address" placeholder="Enter address" value={form.address} onChange={handleChange} rows="3" className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-purple-500 transition resize-none"></textarea>
          </div>

          <button type="submit" className="w-full bg-purple-600 text-white font-semibold py-2.5 rounded-lg shadow-md hover:bg-purple-700 hover:shadow-lg transform hover:scale-[1.02] transition-all duration-200">
            Register Staff
          </button>
        </form>
      </div>
    </div>
  );
}

export default AddStaff;
